/**
 * Product price information summary transformer.
 */
export default class ProductPriceInformationSummaryTransformer {
    /**
     * Extracts the information from the sales price of a product and puts it into properties that are easier to interpret.
     *
     * @param priceInformation Product price information.
     * @param currency ...
     * @returns Product price information summary.
     */
    static transform(priceInformation, currency) {
        const priceInformationSummary = {
            temporaryFamilyPrice: false,
            newLowerPrice: false,
            hasPreviousPrice: false,
            timeRestrictedOffer: false,
            familyPrice: null,
            price: null,
            regularPrice: null
        };
        if (!priceInformation?.salesPrice) {
            return priceInformationSummary;
        }
        const primaryCurrency = [
            ...new Set(priceInformation.salesPrice.map((price) => price.currencyCode))
        ][0];
        const salesPrices = currency
            ? [...priceInformation.salesPrice]
                .filter((salesPrice) => salesPrice.currencyCode === currency)
                .reverse()
            : [...priceInformation.salesPrice]
                .filter((salesPrice) => salesPrice.currencyCode === primaryCurrency)
                .reverse();
        const isFamilyAndNLP = () => {
            const isFamily = salesPrices.some((salesPrice) => salesPrice.typeCode === 'IKEAFamilySalesUnitPrice');
            const isNLP = salesPrices.some((salesPrice) => salesPrice.typeCode === 'RegularSalesUnitPrice' &&
                salesPrice.changeReason === 'NewLowerPrice');
            return isFamily && isNLP;
        };
        const isFamilyAndNLPPrice = isFamilyAndNLP();
        for (const salesPrice of salesPrices) {
            if (salesPrice.typeCode === 'IKEAFamilySalesUnitPrice') {
                priceInformationSummary.familyPrice = salesPrice;
                if (salesPrice.changeReason === 'Temporary') {
                    priceInformationSummary.temporaryFamilyPrice = true;
                }
            }
            else if (salesPrice.changeReason === 'NewLowerPrice') {
                priceInformationSummary.newLowerPrice = true;
                priceInformationSummary.price = salesPrice;
                if (salesPrice.previousSalesPrice) {
                    priceInformationSummary.hasPreviousPrice = true;
                    if (isFamilyAndNLPPrice) {
                        priceInformationSummary.regularPrice = Object.assign({}, salesPrice);
                    }
                    else {
                        priceInformationSummary.regularPrice = Object.assign({}, salesPrice, salesPrice.previousSalesPrice);
                    }
                }
            }
            else if (salesPrice.changeReason === 'TimeRestrictedOffer') {
                priceInformationSummary.timeRestrictedOffer = true;
                priceInformationSummary.price = salesPrice;
                if (salesPrice.previousSalesPrice) {
                    priceInformationSummary.hasPreviousPrice = true;
                    priceInformationSummary.regularPrice = Object.assign({}, salesPrice, salesPrice.previousSalesPrice);
                }
            }
            else if (priceInformation.salesPrice.length > 1) {
                priceInformationSummary.regularPrice = salesPrice;
            }
            else {
                priceInformationSummary.price = salesPrice;
            }
        }
        if (!priceInformationSummary.price && priceInformationSummary.regularPrice) {
            priceInformationSummary.price = priceInformationSummary.regularPrice;
        }
        return priceInformationSummary;
    }
}
//# sourceMappingURL=ProductPriceInformationSummaryTransformer.js.map